import { Chip } from "@mui/material";

// Ported from the tasks monolith's EpicStatusPill — same six states, same
// meaning: an override a person set, or what the rollup and the target date
// say when nobody has.
const LABEL = {
  not_started: "Not started", in_progress: "In progress", on_track: "On track",
  at_risk: "At risk", blocked: "Blocked", done: "Done",
};
const COLOR = {
  not_started: "default", in_progress: "info", on_track: "info",
  at_risk: "warning", blocked: "error", done: "success",
};

export default function EpicStatusPill({ status, size = "small" }) {
  return (
    <Chip size={size} label={LABEL[status] || status} color={COLOR[status] || "default"}
      variant={status === "not_started" ? "outlined" : "filled"}
      sx={{ fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.3,
            fontSize: size === "small" ? 10 : 11 }} />
  );
}
